/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
    AccountToJSONTyped,
} from './Account';

/**
 * 
 * @export
 * @interface UpdateAccountOutputBody
 */
export interface UpdateAccountOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof UpdateAccountOutputBody
     */
    readonly $schema?: string;
    /**
     * Updated account
     * @type {Account}
     * @memberof UpdateAccountOutputBody
     */
    account: Account;
}

/**
 * Check if a given object implements the UpdateAccountOutputBody interface.
 */
export function instanceOfUpdateAccountOutputBody(value: object): value is UpdateAccountOutputBody {
    if (!('account' in value) || value['account'] === undefined) return false;
    return true;
}

export function UpdateAccountOutputBodyFromJSON(json: any): UpdateAccountOutputBody {
    return UpdateAccountOutputBodyFromJSONTyped(json, false);
}

export function UpdateAccountOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'account': AccountFromJSON(json['account']),
    };
}

export function UpdateAccountOutputBodyToJSON(json: any): UpdateAccountOutputBody {
    return UpdateAccountOutputBodyToJSONTyped(json, false);
}

export function UpdateAccountOutputBodyToJSONTyped(value?: Omit<UpdateAccountOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': AccountToJSON(value['account']),
    };
}

